import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getCustomerById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateCustomer } from "..";

const EditCustomer = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getCustomer();
        else setLoading(false);
    }, [id]);

    const getCustomer = async () => {
        try {
            const { data } = await getCustomerById(id);
            setItem(data.customer);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateCustomer from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_customer' />
};

export default EditCustomer;